import { useEffect, useRef } from "react";
import api from "@/lib/api";

const SUPPORTED = { DE: true, AT: true, CH: true, LI: true };

export const addressSupported = (country) => !!SUPPORTED[(country || "").toUpperCase()];

// PLZ-Mindestlänge je Land (DE=5, AT/CH/LI=4)
const minPlzLen = (country) => ((country || "").toUpperCase() === "DE" ? 5 : 4);

export async function lookupCity(country, postalCode) {
  if (!addressSupported(country) || !postalCode) return null;
  try {
    const { data } = await api.get("/address/city", { params: { country, postal_code: postalCode } });
    return data.primary || null;
  } catch { return null; }
}

export async function lookupStreets(country, postalCode, q, locality) {
  if (!addressSupported(country)) return [];
  try {
    const { data } = await api.get("/address/streets", {
      params: { country, postal_code: postalCode || "", q: q || "", locality: locality || "" },
    });
    return data.streets || [];
  } catch { return []; }
}

// Hook: sobald PLZ vollständig & Stadt leer → Ort automatisch vorschlagen (nicht überschreiben).
export function useCityAutofill(country, postalCode, city, setCity) {
  const lastPlz = useRef("");
  useEffect(() => {
    const plz = (postalCode || "").trim();
    if (plz.length < minPlzLen(country) || plz === lastPlz.current) return;
    if ((city || "").trim()) return; // vom Nutzer eingegebene Stadt nie überschreiben
    lastPlz.current = plz;
    let active = true;
    lookupCity(country, plz).then((c) => { if (active && c) setCity(c); });
    return () => { active = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [country, postalCode]);
}
